<template>
    <div>
        <topTab @handleTab="scrollToElement"></topTab>
        <Banner></Banner>
        <Advantages ref="scroll0"></Advantages>
        <HowToApply ref="scroll1"></HowToApply>
        <Evaluate></Evaluate>
        <Company ref="scroll2"></Company>
        <RepaymentMethods></RepaymentMethods>
        <FQ ref="scroll3"></FQ>
        <PrivacyPolicy ref="scroll4"></PrivacyPolicy>
    </div>
</template>

<script>
import Advantages from '../components/Advantages.vue';
import Banner from '../components/banner.vue';
import Company from '../components/company.vue';
import Evaluate from '../components/evaluate.vue';
import FQ from '../components/FQ.vue';
import HowToApply from '../components/HowToApply.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import RepaymentMethods from '../components/repaymentMethods.vue';
import topTab from '../components/topTab.vue';
export default {
    components: {
        Banner,
        topTab,
        FQ,
        PrivacyPolicy,
        Advantages,
        HowToApply,
        Evaluate,
        Company,
        RepaymentMethods
    },
    data() {
        return {
            active: 0,
        };
    },
    created() {
      this.formateStyle();
    },
    computed: {
      bodyZoom() {
        return document.body.clientWidth < 1730 ? 0.8 : 1;
      }
    },
    methods: {
        scrollToElement(index) {
            const el = this.$refs['scroll' + index];
            if (el) {
                window.scrollTo({
                    behavior: 'smooth',
                    top: el.$el.offsetTop * this.bodyZoom,
                });
            }
        },
        formateStyle() {
          if(document.body.clientWidth < 1730) {
            document.body.style.zoom = this.bodyZoom * 100 + '%';
          }
        }
    }
};
</script>

<style lang="scss" scoped>
.sub_title {
    margin-top: 95px;
    text-align: center;
    white-space: pre-wrap;
    font-size: 38px;
    line-height: 50px;
    font-weight: bold;
    span {
        color: #0069DF;
    }
}

.sub_title:nth-of-type(2) {
    margin-top: 102px;
}

.title_tips {
    color: #6F6F6F;
    font-size: 11px;
    margin-top: 16px;
    text-align: center;
}
.repayment_img {
    width: calc(100% - 220px);
    margin: 58px auto;
    img {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue